var e = {
    1: 4,
    2: 8,
    3: 16,
    4: 24,
    5: 32,
    6: 64,
    7: 88
  },
  o = {
    default: "Akzidenz, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    code: "'Source Code Pro', Menlo, monospace"
  },
  a = {
    Mobile: 320,
    Tablet: 768,
    Desktop: 1024,
    XLDesktop: 1440
  };
export { a as breakpoints, o as fontFamilies, e as spacing };